<template>
	<!--  职位卡片  -->
	<div class="doctor-card" @click="goDetail(item.id)">
		<div class="total-padding">
			<div class="g-flex g-row-between g-weight-font">
				<p class="g-font-18 main-text">{{item.postName}}</p>
				<p class="green-text g-font-14">{{item.salary}}</p>
			</div>
			<div class="g-m-t-3 g-flex remark-text">
				<p class="g-font-14">{{item.qualifications}}</p>
				<p class="g-p-l-10 g-m-r-10">|</p>
				<p class="g-font-14">{{item.workYear}}年经验</p>
			</div>
			<div class="line"></div>
			<div class="g-flex g-font-14">
				<img :src="item.avatar" class="store-img store-avatar" alt="">
				<p class="g-m-l-15 sub-text">{{item.clinicName}}</p>
				<p class="g-flex-right remark-text">{{item.countyName}}</p>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "job-position-card",
		props: ['item'],
		methods: {
			goDetail(id) {
				this.$router.push({
					path: 'job-detail',
					query: {
						id: id
					}
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.doctor-card {
		background: #fff;
		border-radius: 5px;
		box-shadow: 0 0 10px 0 rgba(64, 122, 255, 0.10);
		width: 288px;
		height: 136px;

		.total-padding {
			padding: 17px 15px 13px;
		}

		.store-img {
			width: 30px;
			height: 30px;
			border-radius: 5px;
		}

		.line {
			height: 1px;
			background: #f7f7f7;
			margin: 15px 0 10px;
		}
	}
</style>
